<template>
  <svg id="triangle-icon" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.78508 0.841158C0.486778 0.521548 0.713419 0 1.15061 0L12.8494 0C13.2866 0 13.5132 0.521549 13.2149 0.841159L7.36553 7.10836C7.16786 7.32015 6.83214 7.32015 6.63447 7.10836L0.78508 0.841158Z" fill="currentColor"/>
  </svg>
</template>

<script>
  export default {};
</script>
